import ApiManager from '../../utils/ApiManager'

const state = {
  initLoaded: false,
  list: {
    loading: false,
    rowsPerPage: 20,
    totalItems: 0,
    headers: [
      { text: 'お知らせタイトル', align: 'left', value: 'title', type: 'link', sortable: false },
      { text: '表示期間', align: 'left', value: 'display_term', sortable: false },
      { text: '対象企業名', align: 'left', value: 'contract_name', sortable: false },
      { text: '対象ユーザー名', align: 'left', value: 'user_name', sortable: false },
      { text: '表示重要度', align: 'left', value: 'display_order', sortable: false },
      { text: '複写', align: 'center', value: '', type: 'copy', sortable: false }
    ],
    items: []
  }
}

const actions = {
  /**
   * お知らせデータ取得
   */
  async getNewsData ({ state, commit }, { pageNo, sortField, sortType, freeword, contractId }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Notice').noticeList(
      pageNo,
      state.list.rowsPerPage,
      sortField,
      sortType,
      freeword,
      contractId
    )
    commit('setList', response.data)
  },
  async doDelete ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Notice').noticeDelete(deleteIds)
    if (response.data.code === 200000) {
      commit('afterDeleted', deleteIds)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  }
}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterDeleted (state, data) {
    this.dispatch('loading/loadingPageMinus')
    this.dispatch('pagenewslist/getNewsData', {
      pageNo: 1,
      sortField: null,
      sortType: null
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
